<app-comparison-table
  *ngIf="!(error$ | async) && !!(data$ | async)?.length"
  [headers]="tableHeader"
  [data]="data$ | async"
  [ignoreIfSecondIsNull]="true"
  (fieldMismatch)="handleFieldMismatch($event)" />
<app-hint-card [outlined]="true" [type]="'info'" *ngIf="!(error$ | async) && !(data$ | async)?.length">
  <span style="color: inherit">Die Informationen vom Marktstammdatenregister werden geladen...</span>
</app-hint-card>

<app-hint-card [outlined]="true" [type]="'danger'" *ngIf="error$ | async as error">
  <h2 style="color: inherit">{{ error.title }}</h2>
  <p>{{ error.message }}</p>
  <p *ngIf="error.hint" class="mastr-error-hint">{{ error.hint }}</p>
</app-hint-card>
